import { RouteLocationRaw, useRoute, useRouter } from 'vue-router';
export function useRouterHook() {
  const router = useRouter();
  const route = useRoute();
  const goto = (to: RouteLocationRaw, target?: string | undefined) => {
    const ownType = route.meta?.ownType;

    if (target === '_blank' && ownType === 'MyWorkspace') {
      const url = router.resolve(to);
      window.open(url.href, target);
      return;
    }
    // if (target === '_blank') {
    //   const url = router.resolve(to);
    //   window.open(url.href, target);
    //   return;
    // }
    router.push(to);
  };

  const windowClose = () => {
    const ownType = route.meta?.ownType;
    if (ownType === 'MyWorkspace' || history.state.position === 0) {
      window.close();
      return;
    }
    router.go(-1);
  };

  return {
    goto,
    router,
    windowClose,
  };
}

export function useRouteHook() {
  const route = useRoute();

  return {
    route,
    meta: route.meta,
    query: route.query,
    ownType: route.meta?.ownType,
  };
}
